// Kept outside the main bundle and loaded only for legacy FBX. Each import gets
// its own WASM heap, which can be collected afterwards instead of retaining the
// largest imported model's memory for the lifetime of the authoring page.
export async function parseLegacyFbx(buffer) {
    const moduleUrl = new URL("./ufbx/ufbx.mjs", import.meta.url).href;
    let wasm;
    try {
        const { default: createModule } = await import(moduleUrl);
        wasm = await createModule();
    } catch (cause) {
        throw new Error("The legacy FBX importer could not load. Check your connection and try importing again.", { cause });
    }
    const ptr = wasm._malloc(buffer.byteLength);
    if (!ptr) throw new Error("There is not enough memory to import this FBX.");
    try {
        wasm.HEAPU8.set(new Uint8Array(buffer), ptr);
        const result = JSON.parse(wasm.UTF8ToString(wasm._parse(ptr, buffer.byteLength)));
        if (result.error) throw new Error(`Could not read FBX: ${result.error}`);
        const copy = (value, key) => {
            if (!value || typeof value !== "object") return value;
            if (value.ptr !== undefined && value.count !== undefined) {
                const Type = key === "content" ? Uint8Array : key === "slots" ? Uint32Array : key === "joints" ? Uint16Array : Float32Array;
                return new Type(wasm.HEAPU8.buffer, value.ptr, value.count).slice();
            }
            if (Array.isArray(value)) return value.map(item => copy(item, key));
            return Object.fromEntries(Object.entries(value).map(([name, item]) => [name, copy(item, name)]));
        };
        return copy(result);
    } finally {
        wasm._release();
        wasm._free(ptr);
    }
}
